import React from "react";
import classnames from "classnames";
import { injectIntl } from "gatsby-plugin-intl";
import Navigation from "../navigation/Navigation";
import Footer from "../footer/Footer";
import "../../styles/index.scss";
import cssClass from "./Layout.module.scss";

const Layout = ({ children, navInvert, underNav }) => {
  const classes = classnames(cssClass.layout, {
    [cssClass.underNav]: underNav,
  });

  return (
    <div className={classes}>
      <Navigation invert={navInvert} />
      {children}
      <Footer />
    </div>
  );
};

export default injectIntl(Layout);
